import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const BUY_SUBSCRIPTION_SUCCESS = 'BUY_SUBSCRIPTION :: SUCCESS';

export type TBuySubscriptionSuccessAction = IReduxAction<typeof BUY_SUBSCRIPTION_SUCCESS>;

export const buySubscriptionSuccess = actionGenerator<typeof BUY_SUBSCRIPTION_SUCCESS>(BUY_SUBSCRIPTION_SUCCESS);
